import { DataTableColumnHeader } from "@/components/data-table/data-table-column-header";
import { useTranslation } from "@/hooks/useTranslation";
import { AdminTeamUserDTO } from "@shaarp/common";
import { ColumnDef } from "@tanstack/react-table";
import { Avatar, AvatarImage } from "../ui/avatar";
import DataTableCellAdminTeamUserLicence from "./data-table-cell-admin-team-user-licence";

export const dataTableAdminTeamUsersColumns = () => {
  const { t } = useTranslation();

  return [
    {
      accessorKey: "avatar",
      header: "",
      cell: ({ row }) => {
        const user = row.original;
        return (
          <div className="flex justify-center">
            <Avatar className="w-12 h-12">
              <AvatarImage src={user.imageUrl} alt={user.fullName} />
            </Avatar>
          </div>
        );
      },
      enableSorting: false,
      enableHiding: false,
    },
    {
      id: "Nom",
      accessorKey: "fullName",
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("admin.dataTableAdminTeamUsers.columns.name")}
        />
      ),
      cell: ({ row }) => {
        const user = row.original;

        return <span className="font-bold">{user.fullName}</span>;
      },
    },
    {
      id: "Email",
      accessorKey: "email",
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("admin.dataTableAdminTeamUsers.columns.email")}
        />
      ),
    },
    {
      id: "Rôle",
      accessorKey: "role",
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("admin.dataTableAdminTeamUsers.columns.role")}
        />
      ),
      cell: ({ row }) => {
        const user = row.original;
        return user?.role;
      },
    },
    {
      id: "Licence",
      accessorKey: "licence",
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("admin.dataTableAdminTeamUsers.columns.licence")}
        />
      ),
      cell: ({ row }) => {
        const user = row.original;
        return <DataTableCellAdminTeamUserLicence user={user} />;
      },
    },
    {
      id: "Poste",
      accessorKey: "jobTitle",
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("admin.dataTableAdminTeamUsers.columns.jobTitle")}
        />
      ),
    },
    {
      id: "Téléphone",
      accessorKey: "phoneNumber",
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("admin.dataTableAdminTeamUsers.columns.phoneNumber")}
        />
      ),
    },
  ] as ColumnDef<AdminTeamUserDTO>[];
};
